import * as Sentry from '@sentry/browser';
import { getAppConfig } from '@client/core/config/get-app-config';

/**
 * Report the given Error to a logging service. Varies based on current
 * application config.
 */
export function reportException(e: Error): void {
  const app = getAppConfig();

  if (app.config.sentry.enabled) {
    Sentry.captureException(e);
  } else {
    console.error(e);
  }
}
